import script from "./MultiviewContent.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiviewContent.vue?vue&type=script&setup=true&lang=js"

import "./MultiviewContent.vue?vue&type=style&index=0&id=765c906c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-765c906c"]])

export default __exports__